import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UtilsModule, AxillaCommonModule } from '@axilla/axilla-shared';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FriendProfilePictureComponent } from './friend-profile-picture.component';


@NgModule({
    imports: [
        CommonModule,
        AxillaCommonModule,
        UtilsModule,
        ProgressSpinnerModule
    ],
    providers: [

    ],
    declarations: [
        FriendProfilePictureComponent
    ],
    exports: [
        ProgressSpinnerModule,
        FriendProfilePictureComponent,
        UtilsModule
    ]
})
export class WebshopUtilsModule { }
